// extracted by mini-css-extract-plugin
export var cardTitle = "_it-1";
export var commentBubble = "_it-e";
export var commentForm = "_it-a";
export var commentInput = "_it-b";
export var commentLabel = "_it-d";
export var commentPrompt = "_it-9";
export var csatCard = "_it-0";
export var feedbackSection = "_it-7";
export var starDisabled = "_it-6";
export var starEmpty = "_it-5";
export var starFilled = "_it-4";
export var starWrapper = "_it-3";
export var starsContainer = "_it-2";
export var submittedComment = "_it-c";
export var thankYouText = "_it-8";